import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Seo from "../components/Seo";

export default function Privacy() {
  return (
    <div className="min-h-screen">
      <Seo
        title="Privacy Policy"
        description="Informativa sulla privacy di dailybrickdeals.com: come raccogliamo, usiamo e proteggiamo i tuoi dati personali."
        path="/privacy"
      />
      <Header />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link
          to="/"
          data-testid="privacy-back"
          className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white mb-8"
        >
          <ArrowLeft size={14} /> Home
        </Link>

        <div className="font-mono-bdd text-xs uppercase tracking-[0.3em] text-[#FBD51C] mb-3">
          Informativa
        </div>
        <h1 className="font-display font-black text-4xl text-white mb-8 tracking-tight">
          Privacy Policy
        </h1>

        <div className="prose prose-invert max-w-none space-y-5 text-zinc-300 text-sm leading-relaxed">
          <p>Questa è l&apos;informativa sulla privacy di <strong>www.dailybrickdeals.com</strong>.</p>

          <h2 className="font-display text-2xl text-white mt-8">Conformità al GDPR</h2>
          <p>
            Il Regolamento Generale sulla Protezione dei Dati (GDPR) dell&apos;UE è in vigore dal 25 maggio 2018.
            Condividiamo lo spirito di queste normative e siamo disposti a sostenere tutte le leggi che
            permettano agli utenti di internet di rimanere individui sovrani. Aspiriamo alla privacy per
            scelta e, quando possibile, a non raccogliere e conservare informazioni personali identificabili.
            Raccogliamo informazioni che ci aiutano a offrirti un servizio e un&apos;esperienza migliori
            quando navighi su questo sito, leggi i nostri contenuti e interagisci con i nostri prodotti.
          </p>
          <p>
            In qualsiasi momento sei libero di chiederci di disiscriverti dalla nostra newsletter via email o
            di richiedere che le tue informazioni vengano esportate e inviate per la revisione. Basta
            rispondere all&apos;email in questione e includere &lsquo;GDPR&rsquo; nell&apos;oggetto, oltre
            ai dettagli specifici della tua richiesta. Siamo qui per aiutare.
          </p>
          <p>
            Questa politica sulla privacy è stata compilata per servire meglio coloro che sono preoccupati
            su come le loro &lsquo;informazioni personali identificabili&rsquo; (PII) vengono utilizzate
            online. Le PII, così come utilizzate nella legge statunitense sulla privacy e nella sicurezza
            delle informazioni, sono informazioni che possono essere utilizzate autonomamente o insieme
            ad altre informazioni per identificare, contattare o localizzare una singola persona, o per
            identificare un individuo nel contesto. Ti preghiamo di leggere attentamente la nostra
            informativa sulla privacy per avere una chiara comprensione di come raccogliamo, utilizziamo,
            proteggiamo o gestiamo in altro modo le tue Informazioni Personali Identificabili in
            conformità con il nostro sito web.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Informazioni che raccogliamo</h2>
          <p>
            Raccogliamo le informazioni che ci fornisci quando ti iscrivi alla nostra newsletter, lasci
            un commento o compili un modulo di contatto. Queste informazioni possono includere il tuo
            nome, indirizzo email e qualsiasi altra informazione personale che scegli di fornire.
          </p>
          <p>
            Raccogliamo inoltre automaticamente informazioni quando visiti il nostro sito web, inclusi il
            tuo indirizzo IP, il tipo di browser e il tipo di dispositivo. Queste informazioni vengono
            raccolte tramite l&apos;uso di cookie e tecnologie simili.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Come usiamo le tue informazioni?</h2>
          <p>
            Possiamo utilizzare le informazioni che raccogliamo da te quando ti registri, effettui un
            acquisto, ti iscrivi alla nostra newsletter, rispondi a un sondaggio o a una comunicazione di
            marketing, navighi sul sito web o utilizzi alcune altre funzionalità del sito nei seguenti modi:
          </p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Personalizzare l&apos;esperienza dell&apos;utente e permetterci di offrire il tipo di contenuti e prodotti che ti interessano di più.</li>
            <li>Per migliorare il nostro sito web e servirti meglio.</li>
            <li>Per permetterci di servirti meglio rispondendo alle tue richieste di assistenza clienti.</li>
            <li>Per gestire un concorso, una promozione, un sondaggio o altre funzionalità del sito.</li>
          </ul>

          <h2 className="font-display text-2xl text-white mt-8">Come proteggiamo le informazioni dei visitatori?</h2>
          <p>
            Il nostro sito web viene scansionato regolarmente alla ricerca di falle di sicurezza e
            vulnerabilità note, al fine di rendere la tua visita al nostro sito il più sicura possibile.
            Utilizziamo la scansione normale del malware.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Utilizziamo i cookie?</h2>
          <p>
            Sì. I cookie sono piccoli file che un sito o il suo fornitore di servizi trasferisce sull&apos;hard
            disk del tuo computer tramite il browser web (se lo permetti), che consente ai sistemi del sito
            o del fornitore di servizi di riconoscere il tuo browser e di catturare e ricordare alcune
            informazioni. Vengono inoltre utilizzati per aiutarci a comprendere le tue preferenze in base
            all&apos;attività precedente o attuale del sito, il che ci permette di offrirti servizi migliorati.
            Utilizziamo anche i cookie per aiutarci a raccogliere dati aggregati sul traffico e sulle
            interazioni del sito, così da poter offrire esperienze e strumenti migliori in futuro.
          </p>
          <p>Utilizziamo i cookie per:</p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Comprendere e salvare le preferenze degli utenti per le visite future.</li>
            <li>Raccogliere dati aggregati sul traffico e sulle interazioni con il sito per offrire esperienze e strumenti migliori in futuro.</li>
          </ul>
          <p>
            Potremmo anche utilizzare servizi terzi affidabili che tracciano queste informazioni per
            nostro conto. Puoi scegliere di far avvisare il tuo computer ogni volta che viene inviato un
            cookie, oppure puoi scegliere di disattivare tutti i cookie. Lo fai tramite le impostazioni
            del browser. Ogni browser è un po&apos; diverso, quindi consulta il menu Aiuto del tuo
            browser per scoprire il modo corretto di modificare i tuoi cookie. Se disattivi i cookie,
            alcune funzionalità verranno disabilitate e alcuni dei nostri servizi potrebbero non
            funzionare correttamente.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Divulgazione a terzi</h2>
          <p>
            Non vendiamo, scambiamo o trasferiamo a terzi le tue informazioni personali identificabili a
            meno che non ti forniamo un preavviso. Questo non include i partner di hosting del sito web e
            altre parti che ci assistono nella gestione del nostro sito, nella gestione delle attività o
            nel servizio agli utenti, purché tali parti accettino di mantenere queste informazioni
            riservate. Potremmo anche divulgare le tue informazioni quando riteniamo che sia appropriato
            per rispettare la legge, far rispettare le politiche del nostro sito o proteggere i nostri
            diritti, la proprietà o la sicurezza di altri.
          </p>
          <p>
            Tuttavia, informazioni non personalmente identificabili sui visitatori possono essere fornite
            ad altre parti per marketing, pubblicità o altri usi.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Collegamenti di terze parti</h2>
          <p>
            Occasionalmente, a nostra discrezione, possiamo includere o offrire prodotti o servizi di
            terze parti sul nostro sito web. Questi siti di terze parti hanno politiche sulla privacy
            separate e indipendenti. Pertanto, non abbiamo alcuna responsabilità per i contenuti e le
            attività di questi siti collegati. Tuttavia, cerchiamo di proteggere l&apos;integrità del
            nostro sito e accogliamo con favore qualsiasi feedback su questi siti.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Google</h2>
          <p>
            Le esigenze pubblicitarie di Google possono essere riassunte dai Principi Pubblicitari di
            Google. Sono stati messi in atto per offrire un&apos;esperienza positiva agli utenti.
            Potremmo utilizzare Google AdSense sul nostro sito web. Google, in quanto fornitore terzo,
            utilizza i cookie per mostrare annunci sul nostro sito. L&apos;uso del cookie DART da parte
            di Google le permette di mostrare annunci ai nostri utenti in base alla loro visita al
            nostro sito e ad altri siti su Internet. Gli utenti possono rinunciare all&apos;uso del
            cookie DART visitando l&apos;informativa sulla privacy della rete di annunci e contenuti di
            Google.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Legge californiana sulla protezione della privacy online (CalOPPA)</h2>
          <p>
            CalOPPA è la prima legge statale del paese a richiedere che i siti web commerciali e i
            servizi online pubblichino una politica sulla privacy. La portata della legge va ben oltre la
            California per richiedere a una persona o azienda negli Stati Uniti (e possibilmente nel
            mondo) che gestisce siti web che raccolgono informazioni personali identificabili dai
            consumatori californiani di pubblicare una politica sulla privacy evidente sul proprio sito
            web che indichi esattamente le informazioni raccolte e le persone con cui viene condivisa,
            e di rispettare questa politica.
          </p>
          <p>Secondo CalOPPA, concordiamo quanto segue:</p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Gli utenti possono visitare il nostro sito in modo anonimo.</li>
            <li>Il link alla nostra Privacy Policy è disponibile sulla home page e in tutte le pagine principali del sito.</li>
            <li>Il nostro link alla Privacy Policy include la parola &lsquo;Privacy&rsquo; e può essere facilmente trovato.</li>
            <li>Gli utenti saranno informati di eventuali cambiamenti nelle politiche sulla privacy sulla nostra pagina della Informativa sulla Privacy.</li>
            <li>Gli utenti possono modificare le proprie informazioni personali scrivendoci tramite il canale Telegram.</li>
          </ul>

          <h2 className="font-display text-2xl text-white mt-8">Come gestisce il nostro sito i segnali Do Not Track?</h2>
          <p>
            Rispettiamo i segnali Do Not Track e non tracciamo, non piazziamo cookie o utilizziamo
            pubblicità quando è attivo un meccanismo di browser Do Not Track (DNT).
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Tracciamento comportamentale di terze parti</h2>
          <p>
            È importante notare che consentiamo il tracciamento comportamentale da parte di terze parti
            (in particolare Google AdSense) per la personalizzazione della pubblicità.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">COPPA (Legge sulla Protezione della Privacy dei Bambini Online)</h2>
          <p>
            Quando si tratta di raccogliere informazioni personali da bambini sotto i 13 anni, il
            Children&apos;s Online Privacy Protection Act (COPPA) mette i genitori al comando. La
            Federal Trade Commission, l&apos;agenzia nazionale per la protezione dei consumatori, applica
            la Regola COPPA, che specifica cosa devono fare gli operatori di siti web e servizi online
            per proteggere la privacy e la sicurezza dei bambini online.
          </p>
          <p>Non ci rivolgiamo specificamente ai bambini sotto i 13 anni.</p>

          <h2 className="font-display text-2xl text-white mt-8">Pratiche informative eque (Fair Information Practices)</h2>
          <p>
            I Fair Information Practices Principles costituiscono la spina dorsale della legge sulla
            privacy negli Stati Uniti e i concetti che includono hanno svolto un ruolo significativo
            nello sviluppo delle leggi sulla protezione dei dati in tutto il mondo. Per essere in linea
            con le Fair Information Practices, adotteremo le seguenti misure di risposta nel caso in
            cui si verificasse una violazione dei dati:
          </p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Avviseremo gli utenti via email entro 7 giorni lavorativi.</li>
            <li>Concordiamo con il principio del rimedio individuale, che richiede che gli individui abbiano il diritto di perseguire diritti legalmente applicabili contro i raccoglitori e i processori di dati che non rispettano la legge.</li>
          </ul>

          <h2 className="font-display text-2xl text-white mt-8">Legge CAN-SPAM</h2>
          <p>
            Il CAN-SPAM Act è una legge che stabilisce le regole per le email commerciali, stabilisce i
            requisiti per i messaggi commerciali, concede ai destinatari il diritto di avere le email
            impedite di essere inviate loro e stabilisce pene severe per le violazioni.
          </p>
          <p>Raccogliamo il tuo indirizzo email per:</p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Inviare informazioni, rispondere a richieste e/o altre domande.</li>
            <li>Elaborare gli ordini e inviare informazioni e aggiornamenti relativi agli ordini.</li>
            <li>Inviarti ulteriori informazioni relative al tuo prodotto e/o servizio.</li>
            <li>Fare marketing sulla nostra mailing list o inviare email ai nostri clienti dopo che la transazione originale è avvenuta.</li>
          </ul>
          <p>Per essere in conformità con CAN-SPAM accettiamo quanto segue:</p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>NON usare argomenti o indirizzi email falsi o fuorvianti.</li>
            <li>Identificare il messaggio come una pubblicità in modo ragionevole.</li>
            <li>Includere l&apos;indirizzo fisico della nostra sede aziendale o del sito.</li>
            <li>Monitorare i servizi di email marketing di terze parti per la conformità.</li>
            <li>Onorare rapidamente le richieste di rinuncia o disiscrizione.</li>
            <li>Consentire agli utenti di disiscriversi utilizzando il link in fondo a ogni email.</li>
          </ul>
          <p>
            Se in qualsiasi momento desideri disiscriverti dal ricevere future email, puoi scriverci o
            seguire le istruzioni in fondo a ogni email, e ti rimuoveremo prontamente da TUTTA la
            corrispondenza.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Link affiliati Amazon, eBay, AliExpress</h2>
          <p>
            Il Sito contiene link affiliati ad <strong>Amazon</strong>, <strong>eBay</strong>,
            <strong> AliExpress</strong> e altri programmi di affiliazione. Cliccando su un link
            affiliato e completando un acquisto, il Sito può ricevere una commissione
            <strong> senza alcun costo aggiuntivo per te</strong>. Questo aiuta a sostenere il progetto.
          </p>
          <p>
            In qualità di <strong>Affiliato Amazon</strong>, il Sito riceve guadagni dagli acquisti
            idonei effettuati tramite i link presenti nelle pagine.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Marchi e contenuti di terzi</h2>
          <p>
            <strong>dailybrickdeals.com è un canale indipendente, non affiliato né sponsorizzato da The LEGO
            Group.</strong> Tutti i marchi citati (LEGO®, Star Wars™, Harry Potter™, Marvel™, ecc.)
            appartengono ai rispettivi titolari e sono menzionati esclusivamente a fini descrittivi.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Accettare i termini</h2>
          <p>
            Se non accetti l&apos;informativa sulla privacy di dailybrickdeals.com come pubblicata qui su
            questo sito web, ti preghiamo di non acconsentire all&apos;impostazione dei cookie né alla
            raccolta e archiviazione delle tue informazioni personali identificabili. Il tuo consenso
            esplicito indica l&apos;accettazione integrale di questa politica sulla privacy.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Contattarci</h2>
          <p>
            Se ci sono domande riguardo a questa politica sulla privacy, puoi contattarci tramite il
            canale Telegram{" "}
            <a href="https://t.me/BrickDailyDeals" target="_blank" rel="noopener noreferrer" className="text-[#FBD51C]">
              @BrickDailyDeals
            </a>{" "}
            oppure dalla pagina <Link to="/contatti" className="text-[#FBD51C]">Contatti</Link>.
          </p>

          <p className="text-zinc-500 pt-6 border-t border-zinc-800 mt-8">
            Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
